 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import { apiGetAuthorizeCode } from "../../services/api/auth";
import { checkSessionExpiry } from "../../services/session_expiry";

export const openMoocWithSso = async (courseId = null) => {
    if (checkSessionExpiry(["token", "social_token"])) return;

    const newWindow = window.open("about:blank", "_blank");

    try {
        const response = await apiGetAuthorizeCode(process.env.REACT_APP_MOOC_APP_CODE);
        const authorizeCode = _optionalChain([response, 'optionalAccess', _ => _.data, 'optionalAccess', _2 => _2.authorize_code]);
        if (!authorizeCode) throw new Error("Unable to get MOOC authorization code");

        const payload = {
            token: localStorage.getItem("token"),
            expire: localStorage.getItem("expire"),
            social_token: localStorage.getItem("social_token"),
            social_expired: localStorage.getItem("social_expired"),
        };
        const url = new URL(process.env.REACT_APP_MOOC_URL);
        url.searchParams.set("authorize_code", authorizeCode);
        url.searchParams.set("auth", btoa(JSON.stringify(payload)));
        if (courseId != null) url.searchParams.set("course_id", String(courseId));

        if (newWindow) {
            newWindow.location.href = url.toString();
        } else {
            window.location.assign(url.toString());
        }
    } catch (error) {
        _optionalChain([newWindow, 'optionalAccess', _3 => _3.close, 'call', _4 => _4()]);
        throw error;
    }
};
